import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const LIVE_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS}
  query liveNotifications {
    liveNotifications {
      notifications {
        id
        actionKind
        actionButtonLabel
        dismissButtonLabel
        content
        payload
        title
        icon
        imageUrl
        templateKind
        liveSurfaceKind
        priority
        screen
        dismissible
        notification {
          ...NotificationFields
        }
      }
    }
  }
`
